<template>
    <div class="container" id="date" :key="this.$store.state.calendarKey">
        <div class="box">
            <div class="box__inner">
                <h2 v-translate>Rendez-vous disponibles</h2>
                <p v-translate>Veuillez sélectionner la date et l'heure de votre choix. Votre demande sera vérifiée après son envoi et confirmée par courrier électronique.</p>
                <div class="grid">
                    <v-date-picker
                            v-model="date"
                            :available-dates='availableDates'
                            is-inline
                            is-expanded
                            is-required
                            v-on:dayclick='displayTimes'
                            @update:from-page='updateAvailableDates'
                            :attributes='attrs'
                            :locale='this.$store.state.locale'
                            :key="dateKey"
                    />
                    <div>
                        <h3 v-if="this.$store.state.selectedDate.length > 1" class="times-title">{{ this.$store.state.selectedDate }} {{ t('à') }}</h3>
                        <ul class="times">
                            <li v-for="time in availableTimes" :key="time">
                              <input v-on:click="selectTime" type="radio" name="time" :id="time" :checked="$store.state.appointmentAt === time">
                              <label :for="time">{{ getFormattedTime(time) }}</label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    const axios = require('axios');
    const moment = require('moment-timezone');
    const VueScrollTo = require('vue-scrollto');
    var cancelScroll;

    export default {
        name: 'DateTimeSelection',
        data() {
            return {
                date: null,
                availableDates: [],
                responseDates: null,
                availableTimes: [],
                hasSelectedDate: false,
                dateKey: 0,
                needsReload: false,
                hasLimitError: false,
                errorMessage: '',
                attrs: [
                    {
                        key: 'today',
                        dot: {
                            color: 'red',
                            class: 'calendar__dot',
                        },
                        highlight: false,
                        dates: new Date(),
                        selectAttribute: {
                            highlight: 'green',
                        },
                    },
                ],
            };
        },
        mounted() {
            moment.tz.setDefault('Europe/Luxembourg');
        },
        methods: {
            displayTimes(date) {
                const v = this;
                if (this.responseDates[date.id]) {
                    //set times
                    this.availableTimes = Object.entries(this.responseDates[date.id]);
                    this.availableTimes = this.availableTimes.map((time) => {
                        return time[0];
                    });

                    //add to store
                    this.$store.commit('changeData', {
                        type: 'selectedDate',
                        value: date.ariaLabel,
                    });

                    this.$store.commit('changeData', {
                        type: 'selectedDateId',
                        value: date.id,
                    });

                    //reset time if not available on different date
                    if (this.hasSelectedDate) {
                        if (this.availableTimes.some((time) => v.$store.state.selectedTime != time)) {
                            this.$store.commit('changeData', {
                                type: 'selectedTime',
                                value: '',
                            });
                        }
                    }
                    this.hasSelectedDate = true;
                }
            },
            getFormattedTime(datetime) {
                return moment(datetime).format('HH:mm');
            },
            selectTime(ev) {
                this.$store.commit('changeData', {
                    type: 'selectedTime',
                    value: this.getFormattedTime(ev.target.id),
                });

                this.$store.commit('changeData', {
                    type: 'appointmentAt',
                    value: ev.target.id,
                });

                //scroll to section after validated card
                setTimeout(function () {
                    cancelScroll = VueScrollTo.scrollTo('#materiaux', 1000, {
                        onCancel: function () {
                            cancelScroll();
                        },
                    });
                }, 500);
            },
            updateCalendar(response) {
                this.responseDates = response.data;

                // reset times and stored date if user reselects vehicle
                this.availableTimes = [];
                this.$store.commit('changeData', {
                    type: 'selectedDate',
                    value: '',
                });
                if (response.data.length === 0) {
                    this.availableDates = [''];
                } else {
                    for (const key in response.data) {
                        this.availableDates.push(new Date(key));
                    }
                    let date = this.$store.state.selectedDateId ? this.$store.state.selectedDateId : this.availableDates[0];
                    this.displayTimes({
                        id: moment(date).format('YYYY-MM-DD'),
                        ariaLabel: moment(date).locale('fr').format('dddd D MMMM YYYY'),
                    });
                    this.date = new Date(date);

                    // hack to reload calendar only once after axios date error
                    // and focus on first available date
                    if (this.needsReload) {
                        this.dateKey++;
                        this.needsReload = false;
                    }
                }
            },
            updateAvailableDates(page) {
                // reset the dates
                this.availableDates = [];
                axios
                    .get(`${this.$store.state.domain}/api/fr/appointments/available?vehicleTypeId=${this.$store.state.vehicleTypeId}&cardNumber=${this.$store.state.sivecNumber}&year=${page.year}&month=${page.month}`)
                    .then(response => {
                        this.updateCalendar(response);
                    })
                    .catch(error => {
                        if (error.response.status === 405) { // monthly or annual limit reached
                            // show limit error only when trying to reach unavailable dates

                            if (this.hasLimitError) {
                                this.$store.commit('changeData', {
                                    type: 'errorCode',
                                    value: error.response.status
                                });
                                this.$store.commit('addErrorMessage', error.response.data.extraData.message);
                                this.$store.commit('lockApp');
                            }

                            let composedUrl;
                            if (error.response.data.extraData.message.search('mensuelle') > 0) {
                                // monthly limit
                                composedUrl = `${this.$store.state.domain}/api/fr/appointments/available?vehicleTypeId=${this.$store.state.vehicleTypeId}&cardNumber=${this.$store.state.sivecNumber}&year=${page.year}&month=${page.month + 1}`;
                            } else {
                                // yearly limit
                                composedUrl = `${this.$store.state.domain}/api/fr/appointments/available?vehicleTypeId=${this.$store.state.vehicleTypeId}&cardNumber=${this.$store.state.sivecNumber}&year=${page.year + 1}&month=1`;
                            }

                            this.needsReload = true;
                            this.hasLimitError = true;

                            this.errorMessage = error.response.data.extraData.message;
                            axios
                                .get(composedUrl)
                                .then(response => {
                                    this.updateCalendar(response);

                                    // error on yearly limit and no available dates
                                    if (response.data.length === 0) {
                                        this.$store.commit('addErrorMessage', this.errorMessage);
                                        this.$store.commit('lockApp');
                                    }
                                })
                                .catch(error => {
                                    this.$store.commit('changeData', {
                                        type: 'errorCode',
                                        value: null
                                    });
                                    this.$store.commit('addErrorMessage', error.response.data.extraData.message);
                                    this.$store.commit('lockApp');
                                });

                        } else {
                            this.availableDates = [''];
                            if (error.response.status !== 403) { // too much in advance
                                this.$store.commit('addErrorMessage', error.response.data.extraData.message);
                                this.$store.commit('lockApp');
                            }
                        }
                    });
            },
        },
    };
</script>

<style scoped>

    .container {
        position: relative;
        padding-top: 100px;
        padding-bottom: 200px;
    }

    @media only screen and (max-width: 500px) {
        .container {
            padding-bottom: 100px;
        }
    }

    .container::before {
        content: "";
        background-color: var(--green--light);
        position: absolute;
        top: 0;
        right: -50vw;
        bottom: 0;
        left: -50vw;
        z-index: -1;
    }

    .box {
        border-radius: 15px;
        border-top-left-radius: 60px;
        border-bottom-right-radius: 60px;
        background-color: var(--green--dark);
        position: relative;
        padding: var(--large) var(--xmedium);
        padding-bottom: 100px;
    }

    @media only screen and (max-width: 500px) {
        .box {
            padding: var(--xmedium) var(--medium) var(--xlarge);
        }
    }

    .box__inner {
        margin: 0 auto;
        max-width: 900px;
    }

    h2 {
        color: white;
        text-align: center;
    }

    p {
        font-size: 20px;
        color: white;
        margin-bottom: var(--large);
    }

    .grid {
        display: grid;
        gap: var(--xmedium);
        grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
        align-items: flex-start;
    }

    @media only screen and (max-width: 500px) {
        .grid {
            grid-template-columns: 1fr;
        }
    }

    .times-title {
        color: white;
        margin-top: 0;
    }

    .times {
        display: grid;
        gap: var(--medium);
        grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
        align-content: start;
    }

    .times li {
        border-radius: 40px;
        height: 40px;
        overflow: hidden;
        position: relative;
    }

    .times li label {
        font-family: montserrat, sans-serif;
        font-size: 26px;
        font-weight: 700;
        background-color: var(--green--light);
        color: var(--green);
        display: block;
        line-height: 40px;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        text-align: center;
        transition: color 0.2s ease, background-color 0.2s ease;
    }

    .times li label:hover {
        cursor: pointer;
    }

    .times li input:checked + label {
        background-color: var(--green);
        color: white;
    }

    .times li input:disabled + label {
        opacity: 0.5;
    }

    .times li input:disabled {
        opacity: 0;
    }

</style>
<style>
    .calendar__dot {
        background-color: var(--green) !important;
    }

    .vc-day-content.vc-focusable.vc-font-bold.vc-text-white.vc-font-medium.vc-text-sm.vc-cursor-pointer.vc-rounded-full {
        background-color: var(--green) !important;
    }

    .vc-dots {
        transform: translateY(-2px);
    }
</style>
